import { render, staticRenderFns } from "./labelTooltip-editor.vue?vue&type=template&id=50e2bfbe&scoped=true"
import script from "./labelTooltip-editor.vue?vue&type=script&lang=js"
export * from "./labelTooltip-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e2bfbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50e2bfbe')) {
      api.createRecord('50e2bfbe', component.options)
    } else {
      api.reload('50e2bfbe', component.options)
    }
    module.hot.accept("./labelTooltip-editor.vue?vue&type=template&id=50e2bfbe&scoped=true", function () {
      api.rerender('50e2bfbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/labelTooltip-editor.vue"
export default component.exports